import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import axios from 'axios';

const isactiveConformation = ({ id, event, setSearchFlag }) => {
  const closeModal = () => {
    document.getElementById('go-modal-isactive').classList.remove('open');
    setText('');
  };

  const [text, setText] = useState('');
  const [reason, setReason] = useState('');

  const shopifyMerchantActive = (e, merchantId) => {
    let token = localStorage.getItem('token');

    const headers = {
      'Content-Type': 'application/json',
      authorization: token,
    };

    let tempState = '';
    if (e) tempState = 'enable';
    else tempState = 'disable';
    axios
      .post(
        process.env.BASE_URL + '/api/shopify/app-state',
        { mid: merchantId, state: tempState },
        {
          headers: headers,
        }
      )
      .then((res) => {
        toast.success('Operation Successfull', {
          position: 'top-center',
          autoClose: 1500,
        });
        setText('');
        setSearchFlag((prev) => !prev);
        document.getElementById('merchantIsActiveSwitch').checked = event;
        closeModal();
      })
      .catch((err) => {
        let error = err.response.data.message;
        if (!error) error = 'Operation Failed';
        toast.error(error, {
          position: 'top-center',
          autoClose: 1500,
        });
      });
  };

  return (
    <div className='go-modal-isactive' id='go-modal-isactive'>
      <div className='overlay'></div>
      <div className='go-modal-card padding-r1'>
        <a className='close-modal' onClick={closeModal} href='javascript:;'>
          <img src='/images/close.svg' />
        </a>
        <div className='go-modal-header'>
          <div className='form-group metro-r'>
            <label htmlFor='text' className='fs16 lh-16 metro-r text-l-blue margin-b20'>
              To confirm, type {event ? 'Activate' : 'Deactivate'} in the text input field
            </label>
            <input
              type='text'
              className='width-100 form-control'
              placeholder={event ? 'Activate' : 'Deactivate'}
              id='text'
              value={text}
              onChange={(e) => setText(e.target.value)}
            />
          </div>
          {!event && (
            <div className='form-group metro-r'>
              <label htmlFor='reason-text' className='fs16 lh-16 metro-r text-l-blue margin-y20'>
                Reason for Deactivation
              </label>
              <textarea
                className='width-100 form-control'
                rows={5}
                placeholder={'Enter here'}
                id='reason-text'
                value={reason}
                onChange={(e) => setReason(e.target.value)}
              />
            </div>
          )}
        </div>
        <div className='go-modal-content'>
          <div className='form-group margin-r20 text-right'>
            <button
              className={` ${!text || (!event && !reason) ? 'disabled' : ''} blue-btn auto-w-btn`}
              disabled={!text || (!event && !reason)}
              onClick={() => {
                let flag = event ? (text == 'Activate' ? true : false) : text == 'Deactivate' ? true : false;
                if (flag) {
                  shopifyMerchantActive(event, id);
                } else {
                  let err;
                  if (text === '') err = 'Enter Text';
                  else err = 'Entered Wrong Text';
                  toast.error(err, {
                    position: 'top-center',
                    autoClose: 1500,
                  });
                }
              }}
            >
              {event ? 'Activate' : 'Deactivate'}
            </button>
          </div>
          <div className='form-group text-right'>
            <button className='cancel-btn auto-w-btn' onClick={closeModal}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default isactiveConformation;
